import { Injectable, inject, signal, computed } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { filter, startWith } from 'rxjs/operators';

import { TenantUtilities } from '../utilities/tenant-utilities';
//import { TenantDataService } from './datasources/tenant-data.service';


@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly _router = inject(Router);
  //private readonly _tenantDataService = inject(TenantDataService);
  
  private readonly _currentUriTenant = signal<string>(TenantUtilities.getTenantFromRoute());

  public readonly currentUriTenant = this._currentUriTenant.asReadonly();
  
  // Computed signal for tenant display name (could be used for formatting)
  public readonly tenantDisplayName = computed(() => {
    const tenant = this._currentUriTenant();
    return tenant === TenantUtilities.default_tenant ? 'Default Tenant' : tenant;
  });

  get isDemoTenant(): boolean { return this._currentUriTenant() === TenantUtilities.default_tenant; }

  constructor() {
    //this._tenantDataService = inject(TenantDataService);
    
    // Intentional long-lived subscription: TenantService is a singleton (root) and must stay in root so this subscription is not a leak.
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(null) // Emit immediately to set initial value
      )
      .subscribe(() => {
        const newTenant = TenantUtilities.getTenantFromRoute();
        this._currentUriTenant.set(newTenant);
      });
  }
}